import styles from '@/pages/item/styles.module.scss'

import { Helmet } from 'react-helmet';

import { Card } from 'antd';
import { ButtonQuestion } from '@/components/button/question';
import { sendEvent } from '../../utils/ga';

const { Meta } = Card;

export const PageAudience = () => {
  const onAppleClick = (e: React.MouseEvent) => {
    e.preventDefault()

    sendEvent('select_fruit', {
      fruit: 'apple'
    })

    alert('사과를 선택했습니다.')
  }

  const onStrawberryClick  = (e: React.MouseEvent) => {
    e.preventDefault()

    sendEvent('select_fruit', {
      fruit: 'strawberry'
    })

    alert('딸기를 선택했습니다.')
  }

  return (
    <>
      <Helmet>
        <title>마음에 드는 과일을 선택해주세요</title>
      </Helmet>
      <div className={styles.header}>
        <h2>오늘은 과일이 아주 싱싱해요!</h2>
      </div>
      <div className={styles.description}>
        <p>마음에 드는 과일을 선택해주세요</p>
      </div>
      <div className={styles.body}>
        <div className={styles.content}>
          <div className={styles.item}>
            <Card
              hoverable
              style={{ width: 400 }}
              cover={<img alt="example" src="/ga4/apple.jpg"
              onClick={(e) => onAppleClick(e)} />}
            >
              <Meta title="사과" description="오늘은 맛있는 사과를 드셔보세요" />
            </Card>
            <span className={styles.icon}>
              <ButtonQuestion
                content={() => {
                  return (
`
gtag('event', 'select_fruit', {
  fruit: 'apple',
})
`
                  )
                }}
              />
            </span>
          </div>
          <div className={styles.item}>
            <Card
              hoverable
              style={{ width: 400 }}
              cover={<img alt="example" src="/ga4/strawberry.jpg"
              onClick={(e) => onStrawberryClick(e)} />}
            >
              <Meta title="딸기" description="오늘은 맛있는 딸기를 드셔보세요" />
            </Card>
            <span className={styles.icon}>
              <ButtonQuestion
                content={() => {
                  return (
`
gtag('event', 'select_fruit', {
  fruit: 'strawberry',
})
`
                  )
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </>
  )
}